module.exports = __webpack_public_path__ + "img/SellingPoint_2208x1242_1.4585d59e.png";